import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import styles from './style/styles';
import {Button, Grid, withStyles} from 'material-ui';
import {changeRolePermission} from './actions';
import TableRolesPermissionsGroups from './forms/TableRolesPermissionsGroups';
import ScrollToTop from '../../components/scroll-top/ScrollToTop';
import {
    fetchPermissions,
    fetchRoles,
    fetchRolesPermissions,
    fetchPermissionsGroups,
    updateRolesPermissions
} from './thunks';

export class Roles extends React.Component {

    componentWillMount() {
        this.props.fetchRoles();
        this.props.fetchPermissions();
        this.props.fetchRolesPermissions();
        this.props.fetchPermissionsGroups();
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.rolesPermissions !== null &&
            nextProps.roles.length > 0 &&
            nextProps.permissions.length > 0;
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.updateRolesPermissions(this.props.rolesPermissions);
    }

    render() {
        const {
            classes,
            roles,
            permissions,
            rolesPermissions,
            permissionsGroups,
            changeRolePermission,
            loading, touched
        } = this.props;

        return (
            this.props.loading !== true && [
                <form onSubmit={this.handleSubmit.bind(this)} key={0}>
                    <TableRolesPermissionsGroups
                        permissions={permissions}
                        permissionsGroups={permissionsGroups}
                        roles={roles}
                        rolesPermissions={rolesPermissions}
                        changeRolePermission={changeRolePermission}
                        classes={classes}
                    />
                    <Grid container spacing={0} className={classes.root}>
                        <Grid item xs={12} className={classes.buttons}>
                            <Button type="submit" disabled={!touched || loading} variant="raised" color="primary" className="floatRight">{loading ? 'Saving...' : 'Save'}</Button>
                        </Grid>
                    </Grid>
                </form>,
                <ScrollToTop key={1} />
            ]
        );
    }
}

Roles.propTypes = {
    permissions: PropTypes.array.isRequired,
    permissionsGroups: PropTypes.array.isRequired,
    roles: PropTypes.array.isRequired,
    rolesPermissions: PropTypes.array.isRequired,
    changeRolePermission: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    roles: state.roles.allRoles,
    permissions: state.roles.allPermissions,
    rolesPermissions: state.roles.rolesPermissions,
    permissionsGroups: state.roles.permissionsGroups,
    loading: state.layout.ajaxCallsInProgress > 0,
    touched: state.roles.touched,
});

export default connect(mapStateToProps, {
    updateRolesPermissions,
    changeRolePermission,
    fetchRoles,
    fetchPermissions,
    fetchRolesPermissions,
    fetchPermissionsGroups,
})(withStyles(styles)(Roles));


// WEBPACK FOOTER //
// ./src/containers/roles/index.js